import styled from '@emotion/styled';
import type { Prismic } from '@landsbankinn/prismic';
import { Column, device, useMedia } from '@landsbankinn/ui';
import React from 'react';
import { useSpring } from 'react-spring';
import { Img } from '../../img/Img';

const TitleColumn = styled(Column)<{ success?: boolean }>`
  margin-bottom: 45px;
  display: flex;
  justify-content: ${(props) =>
    props.success ? 'space-around' : 'space-between'};
  flex-direction: column;
  padding-top: 24px;

  @media ${device.tablet} {
    padding-top: 100px;
    margin-bottom: 24px;
  }
`;

const ImgColumn = styled(Column)`
  position: relative;
`;

const Image = styled(Img)`
  width: 100%;
  height: 100%;
  min-height: 640px;
  max-height: 640px;
  object-fit: cover;
  transform: translateZ(0px);
`;

export const tempBookAppointmentImage = {
  alt: 'alt texti',
  ar_1_1: {
    alt: null,
    copyright: null,
    dimensions: { width: 1920, height: 1920 },
    url: 'https://images.prismic.io/landsbankinn/0d154aff-96d9-430b-985b-92cb8206d356_Landsbankinn_Uloma_V4A0441.png?auto=compress,format&rect=420,0,1080,1080&w=1920&h=1920',
  },
  ar_4_3: {
    alt: null,
    copyright: null,
    dimensions: { width: 1920, height: 1440 },
    url: 'https://images.prismic.io/landsbankinn/0d154aff-96d9-430b-985b-92cb8206d356_Landsbankinn_Uloma_V4A0441.png?auto=compress,format&rect=240,0,1440,1080&w=1920&h=1440',
  },
  ar_16_9: {
    alt: null,
    copyright: null,
    dimensions: { width: 1920, height: 1080 },
    url: 'https://images.prismic.io/landsbankinn/0d154aff-96d9-430b-985b-92cb8206d356_Landsbankinn_Uloma_V4A0441.png?auto=compress,format&rect=0,0,1920,1080&w=1920&h=1080',
  },
  copyright: null,
  dimensions: { width: 1920, height: 1080 },
  url: 'https://images.prismic.io/landsbankinn/0d154aff-96d9-430b-985b-92cb8206d356_Landsbankinn_Uloma_V4A0441.png?auto=compress,format',
};

interface IProps {
  reverse?: boolean;
  onRest?: () => void;
  image?: Prismic.Image;
  success?: boolean;
}

export const ImageContainer: React.FC<IProps> = ({
  children,
  reverse,
  image,
  onRest,
  success,
}) => {
  const isMobile = useMedia('sm');
  const { x, ...rest } = useSpring({
    reverse,
    onRest,
    from: {
      opacity: 0,
      x: '100%',
    },
    to: { opacity: 1, x: '0%' },

    config: { duration: 300 },
  });

  return (
    <>
      <TitleColumn
        success={success}
        sm={{ offset: 1 / 12, width: 10 / 12, offsetRight: 1 / 12 }}
        md={{ width: 4 / 12, offset: 1 / 12, offsetRight: 1 / 12 }}
      >
        {children}
      </TitleColumn>
      {!isMobile && (
        <ImgColumn sm={{ width: 12 / 12 }} md={{ width: 6 / 12 }} gutter={0}>
          <Image
            style={{ ...rest, transform: x.to((x) => `translate3d(${x},0,0)`) }}
            src={image ?? tempBookAppointmentImage}
          />
        </ImgColumn>
      )}
    </>
  );
};
